import Button from "../core/Button";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import PlayerData from "../PlayerData";
import ConfirmResetPopup from "../ui/ConfirmResetPopup";
import ARIA from "../utils/ARIA";

export default class SplashScene extends ResizableScene {
	private _onResize: () => void;
	container: Phaser.GameObjects.Container;
	playButton: Button;
	resetButton: Button;
	private soundButton: Button;
	private isSoundOn: boolean;
	create(): void {
		super.create();
		this.isSoundOn = !this.soundManager.muted;
		this.music.play("gameMusic");

		const background = this.add.image(0, 0, "splashBG");
		// background.tint = 0xBBBBBB;
		const container = (this.container = this.add.container(0, 0));
		this.add.existing(container);

		const logo = this.add.image(0, 0, "splashLogo");

		const character = this.add.image(0, 0, "splashCharacter");

		const playButton = this.add.button(0, 0, "playBtn", 0, this.play, this, true);
		container.add(playButton);

		const resetButton = (this.resetButton = this.add.button(0, 0, "resetBtn", 0, this.reset, this, true));
		container.add(resetButton);

		const soundButton = (this.soundButton = this.add.button(
			0,
			0,
			this.isSoundOn ? "soundBtnOn" : "soundBtnOff",
			null,
			this.onSoundPressed,
			this,
			true
		));
		soundButton.setScale(0.65);
		if (PlayerData.Instance.saveData.firstTimeUser) {
			resetButton.setVisible(false);
		}

		this._onResize = (): void => {
			ScaleManager.ScaleBackgroundFromZone(background, this.viewport);
			this.alignIn.Center(background, this.viewport);
			this.alignIn.TopRight(logo, this.viewport, -50);
			this.alignIn.Center(character, this.viewport, -300, 100);
			this.alignIn.TopLeft(soundButton, this.viewport, -20, -10);
			this.alignIn.BottomRight(playButton, this.viewport, -110, -30);
			this.alignIn.LeftCenter(resetButton, playButton, 200, 50);
		};
		this.resize();

		// Aria Accessability Setup
		soundButton.setARIA("Toggle Sound");
		ARIA.addTextWithObject(logo, "Ski Training", undefined, true);
		if (resetButton.visible) resetButton.setARIA("Reset Progress");
		playButton.setARIA("Play");

		const charterEndY = character.y;
		character.y += 1500;
		this.tweens.add({
			targets: character,
			y: { from: character.y, to: charterEndY },
			duration: 500,
			ease: Phaser.Math.Easing.Back.Out,
		});

		this.tweens.add({
			targets: [logo, playButton, resetButton],
			scale: { from: 0, to: 1 },
			duration: 800,
			ease: Phaser.Math.Easing.Back.Out,
		});
		logo.scale = 0;
		playButton.scale = 0;
		resetButton.scale = 0;
	}

	protected onSoundPressed(): void {
		//TODO: Mute sounds
		this.soundManager.muted = !this.soundManager.muted;
		this.sound.mute = this.soundManager.muted;
		this.music.muted = !this.music.muted;
		this.isSoundOn = !this.soundManager.muted;
		if (!this.isSoundOn) this.soundButton.setTexture("soundBtnOff");
		else this.soundButton.setTexture("soundBtnOn");
	}

	resize(): void {
		super.resize();
		if (this._onResize != null) this._onResize();
	}

	play(): void {
		this.scene.start("LevelSelectScene");
	}

	reset(): void {
		const popup = new ConfirmResetPopup(
			this,
			() => {
				this.resetButton.setVisible(false);
				this.resetButton.removeARIA();
			},
			this
		);
		this.add.existing(popup);
	}

	shutdown(): void {
		this._onResize = null;
		this.playButton = null;
		this.container = null;
		super.shutdown();
	}
}
